// src/components/QuickLaunch.jsx
import { useLanguage } from "../context/LanguageContext";

const AI_TOOLS = [
  { name: "Gemini", url: "https://gemini.google.com", color: "#4285f4", icon: "✦" },
  { name: "ChatGPT", url: "https://chatgpt.com", color: "#10a37f", icon: "◈" },
  { name: "Grok", url: "https://grok.com", color: "#ffffff", icon: "X" },
  { name: "Copilot", url: "https://copilot.microsoft.com", color: "#0078d4", icon: "❖" },
  { name: "Firefly", url: "https://firefly.adobe.com", color: "#ff4b00", icon: "🔥" },
];

export default function QuickLaunch({ show, onClose }) {
  const { t } = useLanguage();

  if (!show) return null;

  return (
    <div>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      <div style={{
        position: "fixed", bottom: 0, left: 0, right: 0,
        background: "#13131a", borderTop: "1px solid #2a2a3a",
        padding: "16px 24px", zIndex: 200,
        animation: "slideUp 0.3s ease",
        boxShadow: "0 -8px 32px rgba(0,0,0,0.5)",
      }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <div style={{ flex: 1, marginRight: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#10b981" }}>{t("copied_title")}</span>
              <span style={{ fontSize: 12, color: "#555", marginLeft: 8 }}>{t("copied_desc")}</span>
            </div>
            <button onClick={onClose} style={{ background: "none", border: "none", color: "#555", cursor: "pointer", fontSize: 18, lineHeight: 1, padding: "0 4px" }}>x</button>
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {AI_TOOLS.map(function(tool) {
              return (
                <a
                  key={tool.name}
                  href={tool.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex", alignItems: "center", gap: 7,
                    padding: "9px 16px", borderRadius: 10,
                    background: "#0c0c0f", border: "1px solid " + tool.color + "44",
                    color: "#e8e8f0", textDecoration: "none",
                    fontSize: 13, fontWeight: 600, fontFamily: "inherit",
                  }}
                >
                  <span style={{ fontSize: 14, color: tool.color }}>{tool.icon}</span>
                  <span>{tool.name}</span>
                  <span style={{ fontSize: 10, color: "#444" }}>-&gt;</span>
                </a>
              );
            })}
          </div>

          <p style={{ fontSize: 11, color: "#444", marginTop: 10 }}>{t("copied_tip")}</p>

        </div>
      </div>
    </div>
  );
}